var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreakdayLogoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511 106",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#189963",
    points: "29.8,97.2 27.4,106 45.6,106 48.1,97.2 50.5,88.4 32.3,88.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "28,70.8 64.6,70.8 67,62 69.5,53.2 32.9,53.2 32.9,53.2 34.3,48.4 35.4,44.4 35.4,44.4 71.9,44.4  76.8,26.9 40.3,26.9 40.3,26.9 22.1,26.9 22.1,26.9 22,26.9 19.6,35.7 17.2,44.4 17.2,44.4 17.2,44.4 16.7,46 14.7,53.2 12.3,62  9.8,70.8 7.9,77.5 7.4,79.6 4.9,88.4 2.5,97.2 0,106 18.2,106 20.7,97.2 23.1,88.4 25.5,79.9 25.6,79.6 28,70.8  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M80.6,0.5h-0.2v0H47.6l0,0H29.4l0,0h-9.1l-2.4,8.8l-1.1,4l-0.6,2l-0.8,2.8h1.3v0h7.8l0,0h18.2l0,0h37.8 l0,0c3.4,0,6.1,2.7,6.1,6.1c0,0.5-0.1,1-0.2,1.4l-0.2,0.6L86,27.4l-0.3,1L70.2,84c-0.8,2.6-3.2,4.4-5.9,4.4v0h-4.7L54.7,106h9.6v0 c5.3,0,10.2-1.7,14.4-4.9c4-3.1,7-7.5,8.4-12.3l0,0l0,0l0,0l0,0l15.3-54.8l0.1-0.4l0.6-2.3c0,0,0,0,0,0c0.1-0.5,0.3-0.9,0.4-1.3 l0,0v-0.1c0.4-1.8,0.7-3.7,0.7-5.6C104.2,11.1,93.6,0.5,80.6,0.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#189963",
    d: "M126.7,62.6l-4.7,17h-13.7L123,26.9h32.8l-3.3,12h-19.1l-3.2,11.7h16.9l-3.3,12H126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#189963",
    d: "M194.6,77.9l-0.6,1.7h-14.2L175,63h-7.2l-4.6,16.6h-13.8c5-17.7,9.7-35.1,14.6-52.8c7.8,0,15.4-0.1,23.2,0 c12.7,0,16.4,9.4,13.8,18.7c-1.8,6-4.9,11.5-12.1,15.4L194.6,77.9z M180.2,51.8c4.4,0,7.6-4.3,7.8-8c0.2-2.6-1-5-4.2-5h-9.6 l-3.6,13H180.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#189963",
    d: "M249.2,26.9l-3.1,11.3H227l-2.3,8.2h17.6l-3.3,12h-17.6l-2.6,9.3h19.8l-3.3,11.9h-33.6l14.6-52.7H249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#189963",
    d: "M257.6,72.4l-5,7.2h-14.4l0.5-1.9l37.8-51.3h6.9l9.7,51.3l-0.5,1.9h-14.2l-1.4-7.2L257.6,72.4z  M265.1,61.2h10.9l-2-12.4L265.1,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#189963",
    d: "M330.5,79.6l-6.9-20.7l-6.9,0.3l-5.5,20.4h-14.1l14.6-52.7h14l-5.7,20.8c8.3,0.2,9.7-2.3,15-12 c4.1-7.7,10.2-11.4,21.9-8.7l-2.6,9.3c-3.5-0.6-5.7,0.5-7.4,3.8c-4.1,7.5-5.5,11.1-10.5,14.6l9.4,23l-0.6,2H330.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M386.6,27c14.5,0,20.2,10.4,19.5,21.1c-1,15-10.6,31.5-33.3,31.5h-21L366.5,27H386.6z M375.2,67.2 c9.9,0,16.4-8.9,16.9-16.9c0.4-5.6-1.1-10.9-9.1-10.9h-6.2L369,67.2H375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M418.6,72.4l-5,7.2h-14.4l0.5-1.9l37.8-51.3h6.9l9.7,51.3l-0.5,1.9h-14.2l-1.4-7.2L418.6,72.4z  M426.1,61.2H437l-2-12.4L426.1,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M481.9,44.4l14.5-17.5H511l-0.6,2l-26.2,30.6l-5.4,20H465l5.8-20.8l-9.4-29.8l0.6-2h14.6l4.8,17.5H481.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#189963",
    points: "498.8,70.8 508.1,70.8 505.7,79.6 496.3,79.6  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreakdayLogoColor);
export default __webpack_public_path__ + "static/media/freakday_logo_color.4cfc030aaf21eb68b98eb6f5d32ddbc9.svg";
export { ForwardRef as ReactComponent };